export interface Team {
  $id: string;
  Name: string;
  TeamId: number;
}
